export default {
	container: {
		gap: "20px",
		display: "flex",

		"@media(max-width: 1024px)": {
			gap: "5px"
		},

		"@media(max-width: 767px)": {
			flexWrap: "wrap"
		}
	},
	button: {
		minWidth: "108.31px !important",
	},

	exitButton: {
		marginLeft: "auto !important",

		"@media(max-width: 600px)": {
			marginLeft: "inherit !important"
		}
	}
}
